module.exports = __webpack_public_path__ + "img/arrowRight.24407ab2.svg";